import { Box, Flex } from "@chakra-ui/react";
import { AllSetContainer } from "@root/commonStyles/commonStyle";
import { CommonFooter } from "@root/components/auth/commonFooter";
import React from "react";
import { Outlet } from "react-router-dom";

const AllSetLayout: React.FC = () => {
  return (
    <AllSetContainer
      width={"100vw"}
      height={"100vh"}
      overflow={"hidden"}
    >
      <Box height={"100%"} overflowY={"scroll"} pt={4}>
        <Flex justifyContent={"center"} alignItems={"center"} width={"100%"}>
          <Outlet />
        </Flex>
      </Box>
      <Box width={"100%"}>
        <CommonFooter />
      </Box>
    </AllSetContainer>
  );
};

export default AllSetLayout;
